import { render, staticRenderFns } from "./Vip.vue?vue&type=template&id=d2c8f7b0&scoped=true&"
import script from "./Vip.vue?vue&type=script&lang=js&"
export * from "./Vip.vue?vue&type=script&lang=js&"
import style0 from "./Vip.vue?vue&type=style&index=0&id=d2c8f7b0&scoped=true&lang=css&"
import style1 from "./Vip.vue?vue&type=style&index=1&id=d2c8f7b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c8f7b0",
  null
  
)

export default component.exports